import React from "react";
import '../App.css';
import '../blocks/customblocks';
import '../generator/generator';
import styles from "../styles/level1.module.css"
import level0instr from "../images/level0/level0instr.png"
import instrLink from "../images/level0/instrLink.png"
import level0Task0 from '../solutionxml/level0Task0'
import BlocklyComponent, { Block, Value, Field, Shadow } from '../Blockly';
import fulltoolbox from '../toolboxes/fulltoolbox';
import level5xml from '../solutionxml/level5xml'
const level4 = () => {
  return (
    <div className={styles.container}>
    <main>
      <h1 className={styles.title}>
        Level 4: Loops & Conditionals, Arithmetic
      </h1>
      <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> Task 0: Create a counter variable named x that starts at 1. Create a while loop that will repeat the same number of years you’ve been alive. 
         Inside the while loop, write two print statements. The first print statement should print “Happy birthday to me! I’m turning” and the second print statement should print the index of the list. Make sure to increment the counter variable inside the while loop.
        </h3>
        </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}
      >
      </BlocklyComponent>
  </div>
  <br></br>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 1: Create a list with your three of favorite fruits named fruit_list. Somewhere in the fruit list, put your least favorite vegetable. These entries should all be strings. Then create a for loop that loops over each value of fruit_list. Inside the for loop, add an if else statement that evaluates to true if the current value of the list is equal to your least favorite vegetable. In the if statement, include a print statement that prints the string: “Ew! My least favorite vegetable is in the list!” else print “Yum!”
        </h3>
        </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}
      >
      </BlocklyComponent>
  </div>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 2: Set a variable, x, equal to 10. Set a variable, y, equal to 4. Add x and y together and set the sum equal to a variable named z. Set a variable, a, equal to 2. Divide z by a. Print out the quotient. 

        </h3>
        </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}
      >
      </BlocklyComponent>
  </div>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 2: Set a variable, x, equal to 10. Set a variable, y, equal to 4. Add x and y together and set the sum equal to a variable named z. Set a variable, a, equal to 2. Divide z by a. Print out the quotient. 

        </h3>
        </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 1 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}
      >
      </BlocklyComponent>
  </div>
  </main>
  </div>
  );
}
  
export default level4;